<template>
    <q-page class="row">
        <div class="col-12" :class="{ 'row items-center justify-center': centered, 'layout-padding': padding }" @click="yourClickHandler">
            <slot></slot>
        </div>
    </q-page>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { loadMessages } from '../plugins/i18n'
    import { QPage } from 'quasar-framework'
    import axios from 'axios'
    import moment from "moment"

    export default {
        name: 'Page',
        data: () => ({
            appName: window.config.appName,
        }),
        props: {
            padding: Boolean,
            centered: Boolean,
        },
        components: {
            QPage,
        },
        computed: {
            ...mapGetters({
                locale: 'lang/locale',
                locales: 'lang/locales',
                user: 'auth/user',
            }),
            menus() {
                return window.config.menus
            },
        },
        created() {
            window.addEventListener('beforeunload', this.$watchUser('closed'))
        },
        mounted() {
            localStorage.setItem(this.$route.path, moment(document.lastModified).format('YYYY-MM-DD HH:mm:ss'))
        },
        beforeDestroy() {
            this.$watchUser('redirect')
        },
        methods: {
            yourClickHandler(event) {
                let clickNow = {
                    'data': Array(event.target.outerHTML),
                    'date': moment(document.lastModified).format('YYYY-MM-DD HH:mm:ss')
                }
                let parsed = JSON.stringify(clickNow)
                localStorage.setItem('click', parsed)
                this.$watchUser('click')
            },
            
            setLocale(locale) {
                if (this.$i18n.locale !== locale) {
                    loadMessages(locale)
                    this.$store.dispatch('lang/setLocale', { locale })
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Page.vue